import { initStore } from '../../../common';
import { actions } from './actions';

export const resetPassStore = (): void => {
	const initialState = {
		slice: 'RESET_PASS',
		password: '',
		passwordFair: false,
		passwordStrong: false,
		repeatPassword: '',
		repeatInvalid: false,
		two_step_code: '',
		errors: [],
		success: '',
	};

	initStore(actions, initialState);
};
